import { render, staticRenderFns } from "./VideoHolder.vue?vue&type=template&id=162a1232&scoped=true&"
import script from "./VideoHolder.vue?vue&type=script&lang=js&"
export * from "./VideoHolder.vue?vue&type=script&lang=js&"
import style0 from "./VideoHolder.vue?vue&type=style&index=0&id=162a1232&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a1232",
  null
  
)

export default component.exports